import { render, staticRenderFns } from "./CbxIncomeCategory.vue?vue&type=template&id=46f26706&"
import script from "./CbxIncomeCategory.vue?vue&type=script&lang=ts&"
export * from "./CbxIncomeCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports